import axios from 'axios'
import hosts from '@/apis/hostConfig'
import { Indicator } from 'mint-ui';

const instance = axios.create({
  baseURL: hosts[process.env.NODE_ENV].hostName,
  headers:{
    sysCode:'21'
  },
  timeout: 30000,
});

instance.interceptors.request.use(function (config) {
  Indicator.open('加载中...');
  return config;
}, function (error) {
  return Promise.reject(error);
});

instance.interceptors.response.use(function (response) {
  Indicator.close();
  return response;
}, function (error) {
  Indicator.close();
  return Promise.reject(error);
});

export default instance



// WEBPACK FOOTER //
// ./src/apis/axios.js